<div class="panel p-3 mb-3">
    <div class="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
        @if (!appSettings.isMobile()) {
        <h4 class="m-0">Accesos / Menús</h4>
        } @else {
        <h6 class="m-0">Accesos</h6>
        }
        <div class="d-flex gap-2 align-items-center flex-wrap">
            @if (!appSettings.isMobile()) {
            <div class="input-group input-group-sm" style="width: 200px;">
                <span class="input-group-text bg-light border-end-0">
                    <i class="fas fa-search text-muted"></i>
                </span>
                <input type="text" class="form-control border-start-0 ps-0" placeholder="Buscar acceso..."
                    [ngModel]="searchTerm()" (ngModelChange)="searchTerm.set($event)">
            </div>
            }
            @if (canManage()) {
            <button class="btn btn-primary btn-sm" (click)="addMenu()">
                <i class="fas fa-plus"></i> Añadir
            </button>
            }
            @if (canManage() && !editing()) {
            <button class="btn btn-outline-primary btn-sm" (click)="onEdit.emit()">
                <i class="fas fa-edit"></i> Editar
            </button>
            }
            @if (canManage() && editing()) {
            <button class="btn btn-success btn-sm" (click)="onSave.emit()">
                <i class="fas fa-save"></i> Guardar
            </button>
            <button class="btn btn-outline-secondary btn-sm" (click)="onCancel.emit()">
                Cancelar
            </button>
            }
        </div>
    </div>

    @if (appSettings.isMobile()) {
    <div class="mb-2">
        <input type="text" class="form-control py-2 border-0 shadow-sm" placeholder="Buscar acceso..."
            [ngModel]="searchTerm()" (ngModelChange)="searchTerm.set($event)">
    </div>
    <div class="nested-cards-list">
        @for (menu of filteredMenus(); track (menu.uuid || menu.id)) {
            <app-list-card>
                <div cardTitle class="fw-bold text-dark text-truncate">
                    @if (isChild(menu)) {
                    <i class="fas fa-arrow-turn-up fa-rotate-90 me-1 text-muted small"></i>
                    }
                    {{ menu.name }}
                </div>
                <div class="row g-1 text-muted small">
                    <div class="col-3 text-center">
                        <div>Crear</div>
                        <input type="checkbox" class="form-check-input"
                            [checked]="perm(menu, 'canCreate')"
                            [disabled]="!canManage() || !editing()" (change)="togglePermission(menu.uuid || menu.id, 'canCreate')">
                    </div>
                    <div class="col-3 text-center">
                        <div>Leer</div>
                        <input type="checkbox" class="form-check-input"
                            [checked]="perm(menu, 'canRead')"
                            [disabled]="!canManage() || !editing()" (change)="togglePermission(menu.uuid || menu.id, 'canRead')">
                    </div>
                    <div class="col-3 text-center">
                        <div>Editar</div>
                        <input type="checkbox" class="form-check-input"
                            [checked]="perm(menu, 'canUpdate')"
                            [disabled]="!canManage() || !editing()" (change)="togglePermission(menu.uuid || menu.id, 'canUpdate')">
                    </div>
                    <div class="col-3 text-center">
                        <div>Eliminar</div>
                        <input type="checkbox" class="form-check-input"
                            [checked]="perm(menu, 'canDelete')"
                            [disabled]="!canManage() || !editing()" (change)="togglePermission(menu.uuid || menu.id, 'canDelete')">
                    </div>
                </div>
                @if (availableActions(menu); as actionsList) {
                    <div class="mt-2 text-start">
                        <span class="text-muted small fw-semibold">Acciones especiales:</span>
                        <ng-select
                            [items]="actionsList"
                            bindLabel="label"
                            bindValue="key"
                            [multiple]="true"
                            [closeOnSelect]="false"
                            placeholder="Ninguna (solo CRUD)"
                            [ngModel]="menuActions(menu)"
                            [disabled]="!canManage() || !editing()"
                            (ngModelChange)="onSelectActions(menu, $event)">
                        </ng-select>
                    </div>
                }
                @if (canManage() && editing()) {
                <div cardActionsRow>
                    <button type="button" class="btn btn-sm btn-outline-danger w-100" (click)="removeMenu(menu.uuid || menu.id)">
                        <i class="fas fa-trash me-1"></i> Quitar
                    </button>
                </div>
                }
            </app-list-card>
        } @empty {
            <div class="card border-0 shadow-sm p-4 text-center my-2">
                <i class="fas fa-info-circle fa-2x text-muted opacity-50 mb-2"></i>
                <h6 class="text-muted mb-1">{{ searchTerm() ? 'No hay resultados.' : 'No hay accesos asociados.' }}</h6>
            </div>
        }
    </div>
    } @else {
    <div class="table-responsive" style="max-height: 400px; overflow-y: auto;">
        <table class="table table-hover table-sm">
            <thead class="sticky-top shadow-sm">
                <tr>
                    <th>Menú</th>
                    <th class="text-center" title="Crear registros, generar o registrar">Crear</th>
                    <th class="text-center" title="Ver la pantalla y acciones de solo lectura">Leer</th>
                    <th class="text-center" title="Editar, activar/desactivar o escrituras operativas">Editar</th>
                    <th class="text-center" title="Eliminar de forma permanente">Eliminar</th>
                    <th style="min-width: 240px;" title="Acciones especiales y comodín">Acciones Especiales</th>
                    @if (canManage() && editing()) {
                    <th class="text-center">Borrar</th>
                    }
                </tr>
            </thead>
            <tbody>
                @for (menu of filteredMenus(); track (menu.uuid || menu.id)) {
                <tr>
                    <td class="text-nowrap" [class.ps-4]="isChild(menu)">
                        @if (isChild(menu)) {
                        <i class="fas fa-arrow-turn-up fa-rotate-90 me-2 text-muted small"></i>
                        }
                        {{ menu.name }}
                    </td>
                    <td class="text-center">
                        <input type="checkbox" class="form-check-input"
                            [checked]="perm(menu, 'canCreate')"
                            [disabled]="!canManage() || !editing()" (change)="togglePermission(menu.uuid || menu.id, 'canCreate')">
                    </td>
                    <td class="text-center">
                        <input type="checkbox" class="form-check-input"
                            [checked]="perm(menu, 'canRead')"
                            [disabled]="!canManage() || !editing()" (change)="togglePermission(menu.uuid || menu.id, 'canRead')">
                    </td>
                    <td class="text-center">
                        <input type="checkbox" class="form-check-input"
                            [checked]="perm(menu, 'canUpdate')"
                            [disabled]="!canManage() || !editing()" (change)="togglePermission(menu.uuid || menu.id, 'canUpdate')">
                    </td>
                    <td class="text-center">
                        <input type="checkbox" class="form-check-input"
                            [checked]="perm(menu, 'canDelete')"
                            [disabled]="!canManage() || !editing()" (change)="togglePermission(menu.uuid || menu.id, 'canDelete')">
                    </td>
                    <td>
                        @if (availableActions(menu); as actionsList) {
                            <ng-select
                                [items]="actionsList"
                                bindLabel="label"
                                bindValue="key"
                                [multiple]="true"
                                [closeOnSelect]="false"
                                placeholder="Ninguna (solo CRUD)"
                                [ngModel]="menuActions(menu)"
                                [disabled]="!canManage() || !editing()"
                                (ngModelChange)="onSelectActions(menu, $event)">
                            </ng-select>
                        } @else {
                            <span class="text-muted small">—</span>
                        }
                    </td>
                    @if (canManage() && editing()) {
                    <td class="text-center">
                        <button class="btn btn-outline-danger btn-xs" (click)="removeMenu(menu.uuid || menu.id)">
                            <i class="fas fa-trash"></i>
                        </button>
                    </td>
                    }
                </tr>
                } @empty {
                <tr>
                    <td [attr.colspan]="canManage() && editing() ? 6 : 5" class="text-center text-muted p-4">
                        <i class="fas fa-info-circle fa-2x mb-2 d-block opacity-50"></i>
                        {{ searchTerm() ? 'No hay resultados.' : 'No hay accesos asociados.' }}
                    </td>
                </tr>
                }
            </tbody>
        </table>
    </div>
    }
    <div class="form-text text-muted mt-2">
        Pulsá Editar permisos, cambiá los checks y guardá todo junto.
        Un menú nuevo entra solo con Leer. En Facturación: Editar = exportar cobros (todos los contadores); Crear = generar y contabilizar (unión).
    </div>
</div>
